<form [formGroup]="unSignature">
  <axis-card>
    <axis-card-body>
      <h1 class="axis-h3">{{ signatureData?.heading }}</h1>
      <div class="axis-h3">{{ signatureData?.instruction }}</div>
      <div class="axis-h5">{{ signatureData?.sectionTitle }}</div>

      @if (role == "insured") {
        <div
          class="axis-form-group has-axis-required"
          [ngClass]="{
            'has-axis-error': unSignature.get('unSignCheck')?.invalid && unSignature.get('unSignCheck').touched,
          }"
        >
          <axis-checkbox
            [heading]="signatureData?.authorization?.label"
            formControlName="unSignCheck"
            [required]="true"
            class="kind-custom"
            ><span
              aria-hidden="true"
              class="axis-required-indicator"
              >*</span
            ></axis-checkbox
          >
          @if (unSignature.get("unSignCheck")?.invalid && unSignature.get("unSignCheck").touched) {
            <div class="axis-error-block">Please select check box.</div>
          }
        </div>
      }

      @if (role == "broker") {
        <div class="axis-form-group">
          <axis-checkbox
            [heading]="signatureData?.authorization?.label"
            formControlName="unSignCheck"
            [disabled]="true"
          ></axis-checkbox>
        </div>
      }
      @if (role == "insured") {
        <div
          class="axis-form-group"
          [ngClass]="{ 'has-axis-error': showSignatureError }"
        >
          <app-signature
            #signaturePad
            (signatureChange)="onSignatureChange()"
          />
          <div
            class="axis-error-block"
            *ngIf="showSignatureError"
          >
            Please Provide a Signature.
          </div>
        </div>
      }
      @if (role == "broker") {
        <div class="axis-h5">{{ signatureData?.signatureArea?.label }}</div>
      }
      <div class="axis-grid">
        <div class="axis-col-md-6 axis-col-xl-4">
          <div
            class="axis-form-group has-axis-required"
            [ngClass]="{
              'has-axis-error':
                (unSignature.get('unInsuredName').value === '' && unSignature.get('unInsuredName').touched) || unSignature.get('unInsuredName')?.errors?.['pattern'],
              'has-axis-required': unSignature.get('unInsuredName').value === '' ||unSignature.get('unInsuredName')?.errors?.['pattern'] ,
            }"
          >
            <label
              class="axis-control-label"
              for="idSignatureText"
            >
              {{ signatureData?.nameAndTitle?.label }}
            </label>
            <input
              autocomplete="off"
              axis-input-clear
              class="axis-form-control"
              id="idSignatureText"
              type="text"
              formControlName="unInsuredName"
            />
            @if (unSignature.get("unInsuredName").value === "") {
              <div class="axis-error-block">Please enter Name.</div>
            }
            @if(unSignature.get("unInsuredName")?.errors?.['pattern']){
             <div class="axis-error-block">Name and title should only contain letters , blank spaces and acceptable special characters</div> 
            }
          </div>
        </div>
      </div>
      <p class="_text-bold">
        Please note: All signed forms will be available for download following your completion and affirmation of your
        selections, and the application of your signature to the forms. collection.
      </p>
    </axis-card-body>
  </axis-card>
  <div class="axis-btn-wrapper">
    <div class="axis-btn-wrapper-left">
      <button
        axis-button
        class="kind-secondary"
        (click)="onBack()"
      >
        <span class="axis-btn-icon-text">Back</span>
      </button>
    </div>

    @if (role == "insured" || (role == "broker" && !isOnlyUMUIM)) {
      <div class="axis-btn-wrapper-right">
        <button
          axis-button
          class="kind-primary"
          (click)="onContinue()"
        >
          <span class="axis-btn-icon-text">Continue</span>
        </button>
      </div>
    }
  </div>
</form>
